import { Badge } from "@/components/ui/badge";
import { useProductDeal } from "@/hooks/useProductDeal";

interface DealBadgeProps {
  productId: string;
  className?: string;
}

export const DealBadge = ({ productId, className = "" }: DealBadgeProps) => {
  const { deal } = useProductDeal(productId);

  if (!deal) return null;

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <Badge className="bg-destructive text-destructive-foreground font-bold">
        -{deal.discount_percentage}%
      </Badge>
      <Badge variant="secondary" className="text-xs">
        {deal.badge_text}
      </Badge>
    </div>
  );
};
